import views from '../../settings/views/views';
import { selectCurrentView } from './navigationSelectors';
import masterConstants from '../../settings/masterConstants';
import { actionSetWallResizerInactive, actionHideMeasurements } from '../scene';
import { stopAndResetQueuedToasts } from '../../services/toastMaster';
import { thunkSetMargins } from '../scene/sceneThunks';
import { SET_VIEW } from '../actionConstants';
import { Thunk } from '../../generalTypes';
import { Dispatch } from 'react';
import { selectIsWallResizerActive } from '../scene/sceneSelectors';
import { actionDequeueAllSheets } from '../sheets/sheetActions';

/**
 * Set given view
 *
 * @param view
 * @param meta
 * @returns {function(*): void}
 */
// @ts-ignore
export const thunkSetView =
  (view: string, meta: { nonInteraction?: boolean } = {}) =>
  (dispatch: any, getState: any) => {
    const wallresizerActive = selectIsWallResizerActive(getState());
    /**
     * This is placed here, and not in its own action file since it shouldn't be possible
     * to run this action without running parts of below code. Please keep in mind, and do
     * not create an own version of this
     */
    const actionSetView = () => ({
      type: SET_VIEW,
      payload: { view: view },
      meta,
    });

    if (!masterConstants.VIEW_NAMES.hasOwnProperty(view))
      console.error(
        `${view} view does not exist and is therefore not a valid view. Redirecting..`
      );

    const navigatingToStartView = () => {
      return view === masterConstants.VIEW_NAMES.START;
    };

    if (navigatingToStartView()) {
      stopAndResetQueuedToasts();
    }
    dispatch(actionDequeueAllSheets());
    dispatch(thunkInitView(view));
    wallresizerActive &&
      dispatch(actionSetWallResizerInactive({ nonInteraction: true }));
    dispatch(actionHideMeasurements({ nonInteraction: true }));
    dispatch(actionSetView());
    dispatch(thunkSetMargins());
  };

/**
 * Initialize view
 * @param view
 */
export const thunkInitView = (view: string) => (dispatch: Dispatch<any>) =>
  dispatch(views[view].init());

/**
 * Set next view
 * @returns {function(*, *): void}
 */
export const nextView: Thunk = () => (dispatch, getState) => {
  const nextView = views[selectCurrentView(getState())].nextView;

  if (nextView) dispatch(thunkSetView(nextView));
};

/**
 * Set previous view
 * @returns {function(*, *): void}
 */
export const previousView: Thunk = () => (dispatch, getState) => {
  const prevView = views[selectCurrentView(getState())].prevView;

  if (prevView) dispatch(thunkSetView(prevView));
};
